"use strict";
exports.__esModule = true;
exports.logs = exports.requests = void 0;
exports.requests = [
    {
        instance: { uuid: '2c5d0535-26ab-11e9-9284-fa163e41f33d' },
        method: { id: 2, name: 'POST' },
        uuid: '22d4b34e-5d4b-11ea-90f0-42010aac0009',
        url: '/services/T6LSQ91U1/BR2R5M877/x6XGpsltmwCHRAZ5pUStttvP',
        logUser: { uuid: '26efefc4-2498-11e9-9284-fa163e41f33d' },
        name: 'Dev Ops Slack Hook',
        host: ' https://hooks.slack.com',
        logDateAdded: new Date('2020-03-03T12:33:07'),
        logIsLog: false
    }
];
exports.logs = [
    {
        uuid: 'request-log-uuid1',
        responseBody: 'response body',
        request: { uuid: '22d4b34e-5d4b-11ea-90f0-42010aac0009' },
        logDateAdded: new Date(),
        inputs: '{"name": "John Doe"}'
    }
];
